import React from 'react'
import {
  Link as RouterLink,
  Route,
} from 'react-router-dom'
import Radium from 'radium'
import colors from '../../../../theme/colors'
import Triangle from './Triangle'
import Icon from './Icon'
import Width from '../../../Width'

const Link = Radium(RouterLink)

export default Radium(({ to, icon, children, ...rest }) => (
  <Route
    path={to}
  >
    {({ match }) => (
      <Width>
        {({ isSmall }) => (
          <Link
            to={to}
            style={[styles.container, isSmall && styles.small.container]}
            {...rest}
          >
            <div style={[
              styles.content,
              isSmall && styles.small.content,
              match && styles.active.content,
            ]}>
              <Icon component={icon} active={match} />
              <div style={[
                styles.text,
                isSmall && styles.small.text,
              ]}>
                {children}
              </div>
            </div>
            {match && !isSmall && <Triangle />}
          </Link>
        )}
      </Width>
    )}
  </Route>
))

const styles = {
  container: {
    display: 'flex',
    height: '50px',
    textDecoration: 'none',
    color: colors.blackish,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    padding: '0 10px 0 20px',
  },
  text: {
    paddingLeft: '20px',
    fontSize: '14px',
  },
  active: {
    content: {
      backgroundColor: colors.green,
      color: colors.white,
    },
  },
  small: {
    container: {
      flexDirection: 'column',
      height: 'initial',
      width: '100%',
    },
    content: {
      flexDirection: 'column',
      padding: '10px',
    },
    text: {
      paddingLeft: 0,
      paddingTop: '10px',
      textAlign: 'center',
    },
  },
}
